// 渐进增强 Shopify customer 表单；保留原生提交及平台 CAPTCHA 接管。
(function () {
  if (window.trlabNewsletterFeedback) return;
  window.trlabNewsletterFeedback = true;

  function init(root) {
    root.querySelectorAll('[data-newsletter-feedback]').forEach(function (form) {
      if (form.dataset.feedbackReady) return;
      var email = form.querySelector('[name="contact[email]"]');
      var button = form.querySelector('[type="submit"]');
      var message = form.querySelector('[data-newsletter-status]');
      if (!email || !button || !message) return;
      form.dataset.feedbackReady = 'true';
      var pending = false;
      var timer;

      function reset() {
        pending = false;
        clearTimeout(timer);
        button.removeAttribute('aria-disabled');
      }
      function announce(text, error) {
        message.textContent = text;
        message.classList.toggle('cf-form-error', !!error);
      }
      email.addEventListener('invalid', function (event) {
        event.preventDefault();
        reset();
        email.setAttribute('aria-invalid', 'true');
        announce(email.validationMessage, true);
        email.focus();
      });
      email.addEventListener('input', function () {
        reset();
        email.removeAttribute('aria-invalid');
        announce('', false);
      });
      // 仅拦截重复用户操作；不拦截 CAPTCHA 的二次 submit/requestSubmit。
      button.addEventListener('click', function (event) {
        if (pending && event.isTrusted) event.preventDefault();
      });
      email.addEventListener('keydown', function (event) {
        if (pending && event.key === 'Enter' && event.isTrusted) event.preventDefault();
      });
      form.addEventListener('submit', function () {
        if (!email.validity.valid || pending) return;
        pending = true;
        button.setAttribute('aria-disabled', 'true');
        announce(form.dataset.pendingMessage, false);
        timer = setTimeout(function () {
          reset();
          announce(form.dataset.retryMessage, false);
        }, 15000);
      });
      window.addEventListener('pageshow', function () {
        reset();
        announce('', false);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
